import classes from "./Home.module.css";
// import WelcomeMessage from "./Welcome/WelcomeMessage";
// import LeftPanel from "../../layout/leftPanel/LeftPanel";
// import BoxesContainer from "../../../SMARTCITY/components/boxesContainer/BoxesContainer";
// import Charts from "../charts/Charts";
// import styled from "styled-components";

// const Home = () => {
//   return (
//     <BoxesContainer />
//     // <div className={classes.home_container}>
//     //   <LeftPanel
//     //     open={false}
//     //     buttonExpandName={"Γραφήματα"}
//     //     className={classes.leftPanel_Charts}
//     //   >
//     //     <Charts />
//     //   </LeftPanel>
//     //   {/*<LeftPanel*/}
//     //   {/*  open={false}*/}
//     //   {/*  buttonExpandName={"Χρονοσειρές"}*/}
//     //   {/*  className={classes.horizontal_side_panel_tableau}*/}
//     //   {/*>*/}
//     //   {/*</LeftPanel>*/}
//     //   <WelcomeMessage />
//     //   <BoxesContainer />
//     // </div>
//   );
// };

// export default Home;

import WelcomeMessage from "./Welcome/WelcomeMessage";
import BoxesContainer from "../../../SMARTCITY/components/boxesContainer/BoxesContainer";
import styled from "styled-components";

import sponsor1 from "../../../SMARTCITY/assets/images/sponsor_1.png";
import sponsor2 from "../../../SMARTCITY/assets/images/sponsor_2.png";
import sponsor3 from "../../../SMARTCITY/assets/images/sponsor_3.png";
import sponsor4 from "../../../SMARTCITY/assets/images/sponsor_4.png";
import sponsor5 from "../../../SMARTCITY/assets/images/sponsor_5.png";
import bannerArrow from "../../../SMARTCITY/assets/svg/bannerArrow.svg";
import { useState } from "react";
import Box from "../box/Box";
import Meteor from "../categories/meteo/Meteor";
import { useTranslation } from "react-i18next";
import MapPOIS from "../categories/mapPOIS/MapPOIS";
import Weather from "../categories/weather/Weather";

const Home = () => {
  const [hideBanner, setHideBanner] = useState(false);
  const { t } = useTranslation();
  return (
    <Container>
      {/*<LeftPanel*/}
      {/*  open={false}*/}
      {/*  buttonExpandName={"Γραφήματα"}*/}
      {/*  className={classes.leftPanel_Charts}*/}
      {/*>*/}
      {/*  <Charts />*/}
      {/*</LeftPanel>*/}
      {/*<LeftPanel*/}
      {/*  open={false}*/}
      {/*  buttonExpandName={"Χρονοσειρές"}*/}
      {/*  className={classes.horizontal_side_panel_tableau}*/}
      {/*>*/}
      {/*  <Tableau />*/}
      {/*</LeftPanel>*/}
      <WelcomeWrapper>
        <WelcomeMessage />
      </WelcomeWrapper>
      {/* <GridContainer>
        <Box className={classes.large} typeId="1">
          <Meteor
            typeId="1"
            title={t("environmental.title")}
            showSubTitle={true}
            // group="1"
            type={"environmental"}
          />
        </Box>
        <Box className={classes.map_box} typeId="4">
          <MapPOIS typeId="4" title={t("wifi.title")} />
        </Box>
        <Box className={classes.map_box} typeId="30">
          <MapPOIS typeId="30" title={t("benches.title")} />
        </Box>
        <Box className={[classes.medium, classes.weatherBox].join(" ")}>
          <Weather />
        </Box>
      </GridContainer> */}
      <BoxesContainer />
      <BannersWrapper $hideBanner={hideBanner}>
        <Banners $hideBanner={hideBanner}>
          <img src={sponsor1} width={350} />
          <BannersSection>
            <img src={sponsor2} width={76} />
            <img src={sponsor3} width={60} />
            <img src={sponsor4} width={100} />
          </BannersSection>
          <img src={sponsor5} width={200} />
          <BannersArrow
            onClick={() => {
              setHideBanner(!hideBanner);
            }}
          >
            <img
              style={{ opacity: "0.7", transform: "rotate(180deg)" }}
              src={bannerArrow}
              width={40}
            />
          </BannersArrow>
        </Banners>
        <ShowArrow
          $hideBanner={hideBanner}
          onClick={() => {
            setHideBanner(!hideBanner);
          }}
          style={{}}
        >
          <img style={{ opacity: "0.7" }} src={bannerArrow} width={40} />
        </ShowArrow>
      </BannersWrapper>
    </Container>
  );
};

export default Home;

const Container = styled.div`
  position: relative;
  width: 100vw;
  height: calc(100vh - 100px);
  display: flex;
  flex-direction: row;
  align-content: center;
  // overflow: hidden;
  // paddingTop: 70px;

  @media only screen and (max-width: 908px) {
    height: calc(100vh - 150px);
  }
`;

const GridContainer = styled.div`
  width: 100%;
  display: grid;
  grid-template-columns: repeat(
    auto-fill,
    280px
  ); /* Columns for each 280px width item */
  grid-auto-rows: 280px; /* Rows default to 280px, fits both sizes */
  gap: 40px; /* No gap between items */
`;

const WelcomeWrapper = styled.div`
  display: flex;
  width: 420px;

  @media only screen and (max-width: 908px) {
    display: none;
  }
`;

const BannersWrapper = styled.div`
  position: absolute;
  bottom: 10px;
  left: calc((100% - 900px) / 2);
  height: ${({ $hideBanner }) => ($hideBanner ? "50px" : "108px")};
  width: 900px;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  gap: 20px;
  overflow: hidden;
  transition: height 0.3s ease-in-out;
`;

const Banners = styled.div`
  background-color: white;
  width: 900px;
  display: flex;
  flex-direction: row;
  justify-content: space-around;
  align-items: center;
  border-radius: 4px;
  padding: 10px;
  box-shadow: 0 2px 8px 0 rgba(0, 0, 0, 0.2);
  transform: ${({ $hideBanner }) =>
    $hideBanner ? "translateY(108px)" : "translateY(0)"};
  transition: all 0.3s ease-in-out;
  gap: 8px;

  @media only screen and (max-width: 908px) {
    width: 400px;
    flex-direction: column;
    transform: ${({ $hideBanner }) =>
      $hideBanner ? "translateY(266px)" : "translateY(0)"};
  }
`;

const BannersSection = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-around;
  align-items: center;
  gap: 8px;
`;

const BannersArrow = styled.div`
  cursor: pointer;
  width: 46px;
  height: 46px;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #fff;
  border-radius: 50%;
  box-shadow: 0 2px 8px 0 rgba(0, 0, 0, 0.2);
`;

const ShowArrow = styled.div`
  position: absolute;
  bottom: 0;
  cursor: pointer;
  width: 46px;
  height: 46px;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #fff;
  border-radius: 50%;
  box-shadow: 0 2px 8px 0 rgba(0, 0, 0, 0.2);
  transform: ${({ $hideBanner }) =>
    $hideBanner ? "translateY(0)" : "translateY(84px)"};
  transition: all 0.3s ease-in-out;
`;
